/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventDeviceResponseDto } from './EventDeviceResponseDto';
export type EventResponseDto = {
  /**
   * Event ID.
   */
  id: number;
  /**
   * When event was first detected.
   */
  startedAt: string;
  /**
   * When event was last updated.
   */
  lastRepeatedAt: string;
  /**
   * When event was acknowledged.
   */
  acknowledgedAt?: string;
  /**
   * When event ended.
   */
  endedAt?: string;
  /**
   * Describes what concept this event is related to, e.g. battery, smoke, CO, etc.
   */
  name: EventResponseDto.name;
  /**
   * Describes the impact of the event is. Value 'OK' means that event has not occurred.
   */
  value: EventResponseDto.value;
  /**
   * Type (severity level) of the event.
   */
  severity: EventResponseDto.severity;
  /**
   * Device to which the event occurred.
   */
  device: EventDeviceResponseDto;
};
export namespace EventResponseDto {
  /**
   * Describes what concept this event is related to, e.g. battery, smoke, CO, etc.
   */
  export enum name {
    ALL = 'ALL',
    BATTERY_STATUS = 'BATTERY_STATUS',
    CO_STATUS = 'CO_STATUS',
    CO_SELFTEST = 'CO_SELFTEST',
    DEVICE_STATUS = 'DEVICE_STATUS',
    SMOKE_STATUS = 'SMOKE_STATUS',
    HUMID_STATUS = 'HUMID_STATUS',
    HUMID_PREDICTION_STATUS = 'HUMID_PREDICTION_STATUS',
    TEMP_STATUS = 'TEMP_STATUS',
    TEMP_PREDICTION_STATUS = 'TEMP_PREDICTION_STATUS',
    VOC_STATUS = 'VOC_STATUS',
    VOC_PREDICTION_STATUS = 'VOC_PREDICTION_STATUS',
    COVER_STATUS = 'COVER_STATUS',
    FW_DOWNLOAD = 'FW_DOWNLOAD',
    FW_UPDATE = 'FW_UPDATE',
    SIREN_STATUS = 'SIREN_STATUS',
    LOG_SENDING = 'LOG_SENDING',
    EXTERNAL_POWER = 'EXTERNAL_POWER',
    SIGNAL_STATUS = 'SIGNAL_STATUS',
    PRESSURE_STATUS = 'PRESSURE_STATUS',
    HEALTH_STATUS = 'HEALTH_STATUS',
    SMOKE_SENSOR_STATUS = 'SMOKE_SENSOR_STATUS',
    DEVICE_SELF_TEST = 'DEVICE_SELF_TEST',
    CO_SENSOR_SELF_TEST = 'CO_SENSOR_SELF_TEST',
    DOWNLINK_STATUS = 'DOWNLINK_STATUS',
    FIRMWARE_UPDATE_STATUS = 'FIRMWARE_UPDATE_STATUS',
    LOG_STATUS = 'LOG_STATUS',
    NETWORK_STATUS = 'NETWORK_STATUS',
    PAIRING_STATUS = 'PAIRING_STATUS',
    DEVICE_REMINDER = 'DEVICE_REMINDER',
    CO2_STATUS = 'CO2_STATUS',
  }
  /**
   * Describes the impact of the event is. Value 'OK' means that event has not occurred.
   */
  export enum value {
    OK = 'OK',
    LOW = 'LOW',
    HIGH = 'HIGH',
    CRITICALLY_LOW = 'CRITICALLY_LOW',
    FAULT = 'FAULT',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL',
    STARTED = 'STARTED',
    PASSED = 'PASSED',
    CONNECTED = 'CONNECTED',
    DISCONNECTED = 'DISCONNECTED',
    COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
    SATURATED = 'SATURATED',
    INFRARED_LEVEL_INVALID = 'INFRARED_LEVEL_INVALID',
    BLUE_LEVEL_INVALID = 'BLUE_LEVEL_INVALID',
    DIRTY = 'DIRTY',
    NOT_CALIBRATED = 'NOT_CALIBRATED',
    FAILED = 'FAILED',
    REJECTED_BUSY = 'REJECTED_BUSY',
    REJECTED_NOISE = 'REJECTED_NOISE',
    REJECTED_ALARM = 'REJECTED_ALARM',
    INVALID_EVENT_PARAMS = 'INVALID_EVENT_PARAMS',
    TOO_MANY_EVENTS = 'TOO_MANY_EVENTS',
    INVALID_CONFIG = 'INVALID_CONFIG',
    PEER_BUSY = 'PEER_BUSY',
    PATH_INVALID = 'PATH_INVALID',
    DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
    UPDATE_FAILED = 'UPDATE_FAILED',
    ABORTED_ALARM = 'ABORTED_ALARM',
    SIZE_INVALID = 'SIZE_INVALID',
    PEER_SEND_FAILED = 'PEER_SEND_FAILED',
    SAVE_ERROR = 'SAVE_ERROR',
    PEER_OFFLINE = 'PEER_OFFLINE',
    LAST_UPDATE_INCOMPLETE = 'LAST_UPDATE_INCOMPLETE',
    NO_SERVER = 'NO_SERVER',
    NO_TIME = 'NO_TIME',
    UPLOAD_FAILED = 'UPLOAD_FAILED',
    CO_MEASUREMENT_SKIP = 'CO_MEASUREMENT_SKIP',
    SIM_ERROR = 'SIM_ERROR',
    NO_SERVICE = 'NO_SERVICE',
    COMM_PROBLEM = 'COMM_PROBLEM',
    NETWORK_SETUP_ERROR = 'NETWORK_SETUP_ERROR',
    SIGNAL_LOW = 'SIGNAL_LOW',
    TIMEOUT = 'TIMEOUT',
    TOO_MANY = 'TOO_MANY',
    MODEM_FW_ERROR = 'MODEM_FW_ERROR',
  }
  /**
   * Type (severity level) of the event.
   */
  export enum severity {
    INFO = 'INFO',
    WARNING = 'WARNING',
    CRITICAL = 'CRITICAL',
    ERROR = 'ERROR',
  }
}

